var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"ods-breadcrumb",attrs:{"data-name":"OdsBreadcrumb","aria-label":"breadcrumb","role":"navigation"}},[_c('ul',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }